<template>
    <router-view
    ></router-view>
</template>

<script>
export default {
name: "SkupTemaBase",
    methods:{
    }
}
</script>

<style scoped>

</style>